module.exports = __webpack_public_path__ + "4cdcde8a6fcb89a1fbc3385d875ec1b1.svg";


//////////////////
// WEBPACK FOOTER
// ./Content/icons/sets/cloud-icons.svg
// module id = ./Content/icons/sets/cloud-icons.svg
// module chunks = 8